import { useDispatch } from 'react-redux';
import { showSuccessToast, showErrorToast } from '../reducers/toastReducer';

export default function useToastActions() {
  const dispatch = useDispatch();

  const success = (text) => dispatch(showSuccessToast(text));
  const error = (text) => dispatch(showErrorToast(text));

  return { success, error };
}
